import styled from 'styled-components'

export const StyledLonPageHelper = styled.div`
  background: ${({ theme }) => theme.colors.bgBase};
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  .flex-row-around {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around !important;

    > div {
      flex: 1;
    }
  }

  p {
    margin: 0;
  }
  a,
  button {
    cursor: pointer;
  }
  .row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .flex-column-center {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  .lon-card {
    padding: 0;
    border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorder};
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 20px;
    background: ${({ theme }) => theme.colors.lonCardBgLight};

    .flex-row-between {
      padding: 15px 20px;
      background: ${({ theme }) => theme.colors.lonCardBg};
      &:last-child,
      &:nth-last-child(2) {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      /* &:last-child {
        background: ${({ theme }) => theme.colors.lonCardBgLight};
      } */
    }

    &--light {
      background: #fff;
      border: none;

      .flex-row-between {
        background: #fff;
        border: none;
      }

      .button--light,
      a.button--light,
      a.button.button--light {
        background-color: ${({ theme }) => theme.colors.primaryBgLight};
        color: ${({ theme }) => theme.colors.primary};
      }

      .button--dark {
        background-color: ${({ theme }) => theme.colors.primary};
        color: #fff;
      }
    }

    .divider-wrap {
      background: ${({ theme }) => theme.colors.lonCardBg};

      &--light {
        background: transparent;

        .divider {
          width: calc(100% - 40px);
          margin: 0 auto;
        }
      }

      .divider {
        width: calc(100% - 40px);
        margin: 0 auto;
      }
    }
  }

  .lon-cell {
    width: 375px;
    height: 105px;
    background: ${({ theme }) => theme.colors.lonCardBg};
    border: 0.5px solid ${({ theme }) => theme.colors.lonCardBgLight};
    box-sizing: border-box;
    box-shadow: 0px 4px 20px rgba(57, 53, 92, 0.3);
    border-radius: 12px;
    margin: 10px;
    padding: 25px 24px 28px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    dd {
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      opacity: 0.5;
      margin-bottom: 0;
    }
    dt {
      font-weight: bold;
      font-size: 27px;
      line-height: 27px;
      color: #ffffff;
      margin-top: 10px;
    }
  }

  .flex-row-between,
  .flex-row-around {
    width: 750px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    &.dually {
      .mobile-divider {
        display: none;
      }
    }

    dd {
      font-size: 11px;
      line-height: 13px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-bottom: 0;
    }

    dt {
      font-weight: bold;
      font-size: 17px;
      line-height: 21px;
      color: #ffffff;
      margin-top: 9px;
      margin-bottom: 2px;
    }

    button,
    a.button {
      margin: 0;
      border: 0;
      outline: none;
      height: 32px;
      border-radius: 16px;
      font-size: 15px;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      background: ${({ theme }) => theme.colors.lonCardBtnBg};
      padding: 0 15px;
      cursor: pointer;
      white-space: nowrap;
      display: inline-block;

      &.primary {
        background: ${({ theme }) => theme.colors.primary};
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        padding: 0 45px;
      }
    }
  }

  .exchange-header-wrap {
    background: white;
  }

  .normal-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    width: 1200px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.lonCardDivider};
    margin: 15px 0;

    &.light {
      background: white;
      opacity: 0.05;
      width: calc(100% - 40px);
    }

    &.gray {
      background-color: ${({ theme }) => theme.colors.lonCardDividerLight};
    }
  }

  .footer-wrap {
    background: white;
    a {
      text-decoration: none;
    }
  }

  .lon-inner-wrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 80px;
    flex: 1;
  }
  .sub-nav {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  dt.reward-value {
    color: ${({ theme }) => theme.colors.textContent};
  }
  @media screen and (max-width: 960px) {
    min-height: 100vh;
    .flex-row-between,
    .flex-row-around {
      width: unset;
    }
    .exchange-header-wrap {
      display: none;
    }

    .footer-wrap {
      display: none;
    }

    .lon-inner-wrap {
      width: 100%;
      padding: 0 15px 30px;

      .flex-row-between.dually,
      .flex-row-between.single {
        flex-flow: row wrap;
        > div {
          width: 50%;
        }
        .mobile-divider {
          display: block;
          height: 1px;
          width: 100%;
          background: ${({ theme }) => theme.colors.lonCardBorder};
          margin: 13px 0;
        }
      }

      .lon-card {
        width: 100%;
        > div {
          width: 100%;
        }
      }
      .mine {
        .lon-cell {
          width: 100% !important;
        }
      }
    }

    dt.reward-value {
      color: ${({ theme }) => theme.colors.textContent};
    }
  }
`

export const StyledStakingWrap = styled.div`
  margin: 0 auto;
  padding: 120px 0 80px;
  background-color: ${({ theme }) => theme.colors.bgBase};
  .ant-spin-nested-loading {
    z-index: 0;
  }

  ${({ theme }) => theme.media.sm`
    width: 100%;
    padding: 48px 15px 60px;
  `}
`

export const StyledStakingContainer = styled.div`
  .lon-stake-head {
    margin-left: 10px;
    .title-area {
      display: flex;
      align-items: center;

      .title {
        margin-right: 10px;
        color: ${({ theme }) => theme.colors.textContent};
        font-weight: bold;
        font-size: 25px;
        margin-bottom: 0;
      }

      .warn-tip {
        padding: 15px;
        background-color: ${({ theme }) => theme.colors.warningBg};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.warningText};
        font-size: 13px;
        font-weight: 600;
      }
    }
    .description {
      margin-top: 10px;
      color: ${({ theme }) => theme.colors.textMuted};
      font-size: 14px;
      margin-bottom: 0;
      @media (max-width: 640px) {
        font-size: 13px;
      }
    }
  }
  .stake-charts-container {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }
  @media screen and (max-width: 640px) {
    .lon-stake-head {
      .title-area {
        flex-flow: column nowrap;
        align-items: flex-start;
        .warn-tip {
          margin-top: 5px;
          line-height: 15px;
          padding: 10px;
        }
      }
    }
    .stake-charts-container {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .lon-price + .lon-price {
        margin-top: 15px;
      }
      .lon-total-staked-amount + .lon-total-staked-amount {
        margin-top: 15px;
      }
    }
  }
`
